const VIEWBOX_SIZE = 100
const CENTER = VIEWBOX_SIZE / 2
const DOT_RADIUS = 6
const STROKE_WIDTH = 7.5

// Staple path: outer tip → first hex-edge bend → second hex-edge bend → inner tip
// This matches the BetsCycle logo geometry, not a radial line.
const STAPLE_PATH = 'M -9 -30 L 18 -30 L 30 -10 L 4 10'
const OUTER_TIP = { x: -9, y: -30 }

const ARM_ANGLES = [0, 120, 240]
const ARM_COLORS = ['#00B8E8', '#19D7B5', '#00E88F']

const LOADER_STYLES = `
	@keyframes betscycle-loader-rotate {
		0% { transform: rotate(0deg); }
		10%, 33.33% { transform: rotate(120deg); }
		43.33%, 66.66% { transform: rotate(240deg); }
		76.66%, 100% { transform: rotate(360deg); }
	}

	@keyframes betscycle-loader-staple {
		0%, 10% { stroke-dashoffset: 1; opacity: 0; }
		11% { stroke-dashoffset: 1; opacity: 1; }
		21.665% { stroke-dashoffset: 0; opacity: 1; }
		33.33% { stroke-dashoffset: 1; opacity: 1; }
		33.34%, 43.33% { stroke-dashoffset: 1; opacity: 0; }
		44% { stroke-dashoffset: 1; opacity: 1; }
		55% { stroke-dashoffset: 0; opacity: 1; }
		66.66% { stroke-dashoffset: 1; opacity: 1; }
		66.67%, 76.66% { stroke-dashoffset: 1; opacity: 0; }
		77.5% { stroke-dashoffset: 1; opacity: 1; }
		88.33% { stroke-dashoffset: 0; opacity: 1; }
		99% { stroke-dashoffset: 1; opacity: 1; }
		100% { stroke-dashoffset: 1; opacity: 0; }
	}
`

export const BetsCycleLoader = ({ size = 48, className, 'aria-label': ariaLabel = 'Loading' }) => {
	const dimension = typeof size === 'number' ? `${size}px` : size

	return (
		<svg
			className={['betscycle-loader', className].filter(Boolean).join(' ')}
			width={dimension}
			height={dimension}
			viewBox={`0 0 ${VIEWBOX_SIZE} ${VIEWBOX_SIZE}`}
			fill='none'
			role='status'
			aria-label={ariaLabel}
		>
			<style>{LOADER_STYLES}</style>
			<g transform={`translate(${CENTER} ${CENTER})`}>
				<g
					style={{
						transformOrigin: '0 0',
						animation: 'betscycle-loader-rotate 7.5s cubic-bezier(0.4, 0, 0.2, 1) infinite',
					}}
				>
					{ARM_ANGLES.map((angle, index) => (
						<g key={angle} transform={`rotate(${angle})`}>
							<path
								d={STAPLE_PATH}
								pathLength={1}
								stroke={ARM_COLORS[index]}
								strokeWidth={STROKE_WIDTH}
								strokeLinecap='round'
								strokeLinejoin='round'
								style={{
									strokeDasharray: 1,
									strokeDashoffset: 1,
									animation: 'betscycle-loader-staple 7.5s cubic-bezier(0.4, 0, 0.2, 1) infinite',
								}}
							/>
							<circle cx={OUTER_TIP.x} cy={OUTER_TIP.y} r={DOT_RADIUS} fill={ARM_COLORS[index]} />
						</g>
					))}
				</g>
			</g>
		</svg>
	)
}

export default BetsCycleLoader
